import {FormProvider} from 'react-hook-form';
import {getInitialValues} from '../AutoSection';
import {getSchema} from '../AutoSection';
import {getSections} from '../AutoSection';
import {AutoField} from '../fields';
import {useNonPersistentFormMethods} from '../hooks';
import fields from './fields';
import {usePostProfile} from 'hooks/usePostEndpoint';
import FormDialog from '../FormDialog';
import {useContext, useEffect} from 'react';
import {Grid} from '@material-ui/core';
import {UserContext} from 'context/UserContext';

const DeliveryFormDialog = ({buttonText, ...buttonProps}) => {
    const sections = getSections(fields);
    const sectionFields = sections['Delivery Information'];
    const {deliveryInfo, actions} = useContext(UserContext);

    const methods = useNonPersistentFormMethods({
        initialValues: getInitialValues(deliveryInfo, sectionFields, fields),
        schema: getSchema(sectionFields, fields),
    });

    const {post, result, submissionInProgress, error, reset} = usePostProfile();

    useEffect(() => {
        methods.reset(deliveryInfo);
        // eslint-disable-next-line
    }, [deliveryInfo]);

    useEffect(() => {
        if (result?.status === 'ok' && result?.user_profile) {
            actions.updateProfile(result?.user_profile);
        }
        //eslint-disable-next-line
    }, [result]);

    return (
        <FormProvider {...methods}>
            <FormDialog
                title='Delivery Address'
                inProgress={submissionInProgress}
                success={result}
                error={error}
                buttonProps={buttonProps}
                buttonText={buttonText}
                onSubmit={methods.handleSubmit(data => post(data))}
                reset={reset}
            >
                <Grid container spacing={2}>
                    {sectionFields.map((field, index) => (
                        <Grid item xs={12} key={field}>
                            <AutoField
                                field={fields[field]}
                                name={`${field}`}
                                key={`${field}`}
                                autoFocus={index === 0}
                            />
                        </Grid>
                    ))}
                </Grid>
            </FormDialog>
        </FormProvider>
    );
};

export default DeliveryFormDialog;
export {DeliveryFormDialog};
